import { FC, PropsWithChildren, useState } from 'react'
import styles from './main-layout.module.scss'
import Header from '@/components/sections/Header'
import Footer from '@/components/sections/Footer'
import OverlayContext from '@/contexts/overlay.context'
import classNames from '@/utils/helpers/class-names.helper'
import MainModalsContextProvider from '@/providers/main-modals.provider'
import usePromo from '@/hooks/promo.hook'
import Head from 'next/head'

type MainLayoutProps = {
  canonical?: string
}

const MainLayout: FC<PropsWithChildren<MainLayoutProps>> = ({ children, canonical }) => {
  const [activeOverlay, setActiveOverlay] = useState<boolean>(false)

  usePromo()

  return (
    <OverlayContext.Provider value={{ active: activeOverlay, setActive: setActiveOverlay }}>
      <div className={styles.wrapper}>
        <MainModalsContextProvider>
          <div className={classNames('overlay', activeOverlay && '_visible')}></div>
          <Header />
          <main className="main">{children}</main>
          <Footer />
        </MainModalsContextProvider>
      </div>
    </OverlayContext.Provider>
  )
}

export default MainLayout
